module.exports = __webpack_public_path__ + "static/img/group-bg.834a6e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/group-bg.png
// module id = cc1U
// module chunks = 1